import { useEffect, useState } from 'react';

import { format, set } from 'date-fns';

export const useWorkingHours = (practice, stepMinutes = 5) => {
  const [hours, setHours] = useState([]);

  useEffect(() => {
    if (!practice) return;

    const newHours = [];

    const startHr = practice?.working_hours?.startsAt?.hour || 0;
    const endHr = practice?.working_hours?.endsAt?.hour || 24;
    const STEP = 60 % stepMinutes === 0 ? stepMinutes : 5;

    const baseDate = new Date();

    for (let hour = startHr; hour < endHr; hour++) {
      for (let minute = 0; minute < 60; minute += STEP) {
        const d = set(baseDate, { hours: hour, minutes: minute, seconds: 0, milliseconds: 0 });
        newHours.push({
          value: format(d, 'HH:mm'),
          label: format(d, 'h:mm a')
        });
      }
    }
    setHours(newHours);
  }, [practice]);

  return hours;
};
